import CardStyle from "../css/card.module.css";
import data from "../helper/data";

const Card = () => {
  return (
    <div className={CardStyle["container"]}>
      {data.map((item) => {
        return (
          <div className={CardStyle["card"]}>
            <img src={item.photo} alt="img" />
            <div className={CardStyle["background"]}></div>
            <div className={CardStyle["text"]}>
              <h1 className={CardStyle["name"]}>{item.name}</h1>
              <h3 className={CardStyle["number"]}>#{item.number}</h3>
              <p className={CardStyle["position"]}>{item.position}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Card;
